/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import orderBy from 'lodash/orderBy';
import { ReactComponent as CheckCircle } from 'assets/icons/CheckCircle.svg';
import { ReactComponent as EditSvg } from 'assets/icons/New/Edit.svg';
import RequirementTag from '../RequirementTag';
import SubBlock from './Sub';
import classes from './Block.module.scss';

const typeMapping = [
  'success',
  'blue',
  'warning',
  'red',
  'purple',
  'blue1',
  'blue2',
  'pink',
  'success1',
  'warning1',
  'blue3',
  'success2',
  'blue4',
];

const Block = ({
  className,
  data,
  onSubAdd,
  onRemoveDataItem,
  onRemove,
  onComplete,
  onEdit,
  onDuplicate,
  onViewData,
  defaultExpandId,
  onResetExpandDefault,
  indexKey,
}) => {
  const items = data?.items || [];
  const tOrderedItems = orderBy(items, [(item) => (!!item.isMandatory ? 0 : 1)], ['asc']);
  const isCompleted = items.filter((obj) => !!obj.isMandatory).every((obj) => !!obj.isCompleted);
  return (
    <div className={cn(classes.wrapper, className)}>
      <div className={classes.header}>
        <CheckCircle
          className={cn(classes.checkIcon, {
            [classes.checked]: isCompleted,
          })}
        />
        <RequirementTag count={items.length} type={typeMapping[indexKey]}>
          {data?.customType?.name}
        </RequirementTag>
        {/* <span className={classes.editIcon}>
          <EditSvg />
        </span> */}
      </div>
      {items.length > 0 && (
        <div className={classes.list}>
          {tOrderedItems.map((obj, index) => {
            return (
              <SubBlock
                key={`${obj.id}_${index}`}
                data={obj}
                onAdd={() => {
                  if (onSubAdd) onSubAdd(obj);
                }}
                onRemoveDataItem={onRemoveDataItem(obj)}
                onRemove={onRemove(obj)}
                onComplete={onComplete(obj)}
                onEdit={onEdit(obj)}
                onDuplicate={onDuplicate(obj)}
                onViewData={onViewData(obj)}
                defaultExpand={defaultExpandId === obj.id}
                onResetExpandDefault={onResetExpandDefault}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Block;
